/* AUTO GENERATED CONTENT: DO NOT MODIFY THIS FILE. SEE /TOOLS FOLDER FOR CHANGES */

import CSS from 'csstype'
import { TextStyleValue } from '../core-components/text/types'
import { ThemeFontFamily, ThemeFontSizes, ThemeFontWeights, ThemeLineHeights } from './types'

type StrictTextStyleValue = TextStyleValue & {
  fontFamily?: ThemeFontFamily
  fontSize?: ThemeFontSizes
  fontWeight?: ThemeFontWeights
  lineHeight?: ThemeLineHeights | CSS.Property.LineHeight
  textTransform?: CSS.Property.TextTransform
}

export const textPropsByTextStyle = {
  'body-monoline': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '0.875rem',
  },
  'body-multiline': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '1.375rem',
  },
  'body-multiline-tight': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '1.125rem',
  },
  button: {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '0.875rem',
  },
  'calendar-item-declined': {
    fontFamily: 'primary',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '0.875rem',
  },
  cell: {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '0.875rem',
  },
  'cell-heading': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '0.875rem',
  },
  'cell-multiline': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '1.375rem',
  },
  'code-monoline': {
    fontFamily: 'monospace',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '0.875rem',
  },
  'code-multiline': {
    fontFamily: 'monospace',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '1.125rem',
  },
  'detail-m': {
    fontFamily: 'primary',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '1.125rem',
  },
  'detail-s': {
    fontFamily: 'primary',
    fontSize: 10,
    fontWeight: 500,
    lineHeight: '0.625rem',
  },
  'form-label': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '0.875rem',
  },
  'form-label-inline': {
    fontFamily: 'primary',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '0.75rem',
  },
  'form-value': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '0.875rem',
  },
  'form-value-emphasis': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '0.875rem',
  },
  'form-value-multiline': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '1.375rem',
  },
  'heading-2xl': {
    fontFamily: 'primary',
    fontSize: 36,
    fontWeight: 600,
    lineHeight: '2.6875rem',
  },
  'heading-2xs': {
    fontFamily: 'primary',
    fontSize: 10,
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: '0.625rem',
  },
  'heading-l': {
    fontFamily: 'primary',
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '1.25rem',
  },
  'heading-m': {
    fontFamily: 'primary',
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '1rem',
  },
  'heading-s': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '0.875rem',
  },
  'heading-xl': {
    fontFamily: 'primary',
    fontSize: 24,
    fontWeight: 600,
    lineHeight: '1.8125rem',
  },
  'heading-xs': {
    fontFamily: 'primary',
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '0.75rem',
  },
  item: {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '0.875rem',
  },
  'item-selected': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '0.875rem',
  },
  'item-unselected': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '0.875rem',
  },
  'list-group-heading': {
    fontFamily: 'primary',
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '0.75rem',
  },
  'modal-heading': {
    fontFamily: 'primary',
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '1.4rem',
  },
  'multiline-button': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '1.375rem',
  },
  'node-heading': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 700,
    textTransform: 'uppercase',
    lineHeight: '0.875rem',
  },
  'page-section-heading': {
    fontFamily: 'primary',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '0.875rem',
  },
} satisfies Record<string, StrictTextStyleValue>
